import { render, staticRenderFns } from "./DegreeList.vue?vue&type=template&id=7bde557b&scoped=true"
import script from "./DegreeList.vue?vue&type=script&lang=js"
export * from "./DegreeList.vue?vue&type=script&lang=js"
import style0 from "./DegreeList.vue?vue&type=style&index=0&id=7bde557b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bde557b",
  null
  
)

export default component.exports